import React from 'react';
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import { ImportExport } from "@mui/icons-material";
import { UploadFileModal } from "./index";

interface Props {
    status?: boolean;
    data: any;
    element: any;
    ecrfId: string,
    reload?: () => void;
}

export default function UploadFileFormik(params: Props) {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Button
        variant={'outlined'}
        size="small"
        color={'primary'}
        style={{ padding: '5px 30px', width: "100%" }}
        onClick={handleOpen}
        startIcon={<ImportExport />}
      >
        {t('Import data')}
      </Button>

      <UploadFileModal open={open} setOpen={setOpen} handleClose={handleClose} {...params} />
    </>
  );
}